<template>
    <div class="animated fadeInLeft authentication-bg">
        <div class="account-pages">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card mt-4">
                            <!-- Logo -->
                            <div
                                class="card-header pt-3 pb-3 text-center bg-primary"
                            >
                                <span class="text-white font-weight-bold h2">{{
                                    companyName
                                }}</span>
                            </div>
                            <div class="card-body p-4">
                                <div class="text-center w-75 m-auto">
                                    <h4
                                        class="text-dark-50 text-center mt-0 font-weight-bold"
                                    >
                                        Reset Password
                                    </h4>
                                    <p class="text-muted mb-4">
                                        Enter your verification code and you new
                                        password.
                                    </p>
                                </div>
                                <form>
                                    <div class="form-group mb-3 mt-3">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="password"
                                        >
                                            <eb-input
                                                lable="Enter Your Password*"
                                                id="emailaddress"
                                                placeholder="Enter Your Password"
                                                v-model="password"
                                                type="password"
                                                name="email"
                                            ></eb-input>
                                            <span
                                                class="validate-error"
                                                style="color: red"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                        <small
                                            id="passwordHelp"
                                            style="font-size: 13px"
                                            class="form-text text-muted mx-1"
                                            v-if="password"
                                        >
                                            <span
                                                v-if="!has_minimum_lenth"
                                                :class="
                                                    has_minimum_lenth
                                                        ? 'has_required'
                                                        : ''
                                                "
                                                class="validate-error"
                                                >Password should contain atleast
                                                8 characters ,</span
                                            >
                                            <span
                                                v-if="!has_number"
                                                :class="
                                                    has_number
                                                        ? 'has_required'
                                                        : ''
                                                "
                                                class="validate-error"
                                            >
                                                alphanumeric ,
                                            </span>
                                            <span
                                                v-if="!has_uppercase"
                                                :class="
                                                    has_uppercase
                                                        ? 'has_required'
                                                        : ''
                                                "
                                                class="validate-error"
                                            >
                                                first letter of the password
                                                should be capital and</span
                                            >
                                            <span
                                                v-if="!has_special"
                                                :class="
                                                    has_special
                                                        ? 'has_required'
                                                        : ''
                                                "
                                                class="validate-error"
                                            >
                                                one special character (@, $, !,
                                                &, etc)</span
                                            >
                                        </small>
                                    </div>
                                    <div class="form-group mb-3 mt-3">
                                        <eb-input
                                            lable="Enter Confirm Password*"
                                            id="emailaddress"
                                            placeholder="Enter Confirm Password"
                                            v-model="confirmPassword"
                                            type="password"
                                            name="email"
                                        ></eb-input>
                                        <span
                                            v-if="
                                                confirmPassword &&
                                                !passwordValid
                                            "
                                            style="color: red"
                                            >password not matched
                                        </span>
                                    </div>
                                    <div class="form-group mb-3 mt-3">
                                        <eb-input
                                            lable="Enter Verification Code*"
                                            id="emailaddress"
                                            placeholder="Enter Verification Code"
                                            v-model="verificationCode"
                                            type="password"
                                            name="email"
                                            validation="required|email"
                                        ></eb-input>
                                    </div>
                                    <div class="form-group mb-4 text-center">
                                        <button
                                            class="btn btn-primary btn-lg"
                                            @click.prevent="resetPassword"
                                        >
                                            Reset your Password
                                        </button>

                                        <p class="text-muted mt-3">
                                            <a
                                                @click="sendOtpAgain"
                                                class="text-muted ml-1"
                                            >
                                                Resend <b>OTP </b
                                                ><span
                                                    :style="
                                                        3 - sendOtpCount > 1
                                                            ? 'color:green;'
                                                            : 'color:red;'
                                                    "
                                                >
                                                    Only
                                                    {{
                                                        3 - sendOtpCount > 0
                                                            ? 3 - sendOtpCount
                                                            : 0
                                                    }}
                                                    try left</span
                                                >
                                            </a>
                                        </p>
                                    </div>
                                </form>
                            </div>
                            <!--end card-body-->
                        </div>
                        <!-- end card -->
                        <div class="row mt-3 mb-4">
                            <div class="col-12 text-center">
                                <p class="text-muted">
                                    Back to
                                    <router-link to="/login">
                                        <a class="text-muted ml-1">
                                            <b>Log In</b>
                                        </a>
                                    </router-link>
                                </p>
                            </div>
                            <!-- end col -->
                        </div>
                        <!-- end row -->
                    </div>
                    <!--end col -->
                </div>
                <!-- end row -->
            </div>
            <!--  end container -->
        </div>
        <!-- end page -->
    </div>
</template>

<script>
import ebInput from "@/components/FormElements/Input.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
    name: "RecoveryPassword",
    components: {
        ebInput,
        ebSelect,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            has_minimum_lenth: false,
            has_number: false,
            has_uppercase: false,
            setvalues: false,
            has_special: false,
            sendOtpCount: 0,
            error: "",
            verifyData: "",
            password: "",
            confirmPassword: "",
            verificationCode: "",
            companyName:
                JSON.parse(sessionStorage.getItem("companyName")) ||
                "FASTFORGE",
        };
    },
    computed: {
        passwordValid() {
            return (
                this.has_minimum_lenth &&
                this.has_number &&
                this.has_uppercase &&
                this.has_special
            );
        },
        passwordValid() {
            return this.password === this.confirmPassword;
        },
        checkPassword() {
            if (this.password === this.confirmPassword) {
                let regeX =
                    /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
                if (regeX.test(String(this.password))) {
                    return { checkKey: true, message: "" };
                } else {
                    return {
                        checkKey: false,
                        message:
                            "Please 8 letter password, with at least a symbol, upper and lower case letters and a number",
                    };
                }
            } else {
                return { checkKey: false, message: "Password not match" };
            }
        },
    },
    mounted() {
        this.verifyData = this.$store.getters["passwordReset/getInfoGatter"];
    },
    methods: {
        async resetPassword() {
            if (this.checkPassword.checkKey) {
                this.error = this.checkPassword.message;
                let payload = {
                    resetRef: this.verifyData.refId,
                    password: this.password,
                    verificationCode: this.verificationCode,
                };

                this.$store
                    .dispatch("passwordReset/resetPassword", payload)
                    .then((res) => {
                        this.$swal(res);
                        this.$router.push({
                            name: "Login",
                        });
                    });
            } else {
                this.error = this.checkPassword.message;
            }
        },
        sendOtpAgain() {
            if (3 > this.sendOtpCount) {
                this.$store
                    .dispatch("passwordReset/sendPasswordResetEmail", {
                        email: this.verifyData.email,
                        userType: this.verifyData.userType,
                    })
                    .then((data) => {
                        this.$swal(data);

                        this.verifyData =
                            this.$store.getters["passwordReset/getInfoGatter"];
                    });
                this.sendOtpCount++;
            } else {
                this.$swal({
                    type: "error",
                    title: "Error",
                    text: "You have exceed your limit please try again later!",
                });
            }
        },
    },

    watch: {
        password() {
            this.has_minimum_lenth = this.password.length > 7;
            this.has_number = /\d/.test(this.password);
            this.has_uppercase = /[A-Z]/.test(this.password.split("")[0]);
            this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);
        },
    },
};
</script>
<style scoped>
.authentication-bg {
    background-image: url("/img/bg-pattern-light.svg");
    background-size: cover;
    background-position: center;
}
.bg-primary {
    background-color: var(--primary) !important;
}
.card-header:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding: 30px 5px !important;
}
.btn-primary {
    background: rgb(114, 124, 245) !important;
    border: none !important;
    border-radius: 2px !important;
    box-shadow: 0px 1px 5px 1px #989ff0 !important;
}
.form-control {
    height: calc(1.5em + 0.75rem + 10px) !important;
}
.card-body {
    margin: 15px !important;
}
.card {
    border: none !important;
    box-shadow: 0px 1px 5px 1px #cdcfea !important;
}
</style>
